import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { CommunitySchoolStore } from 'state/setting/communitySchool'
import CommunitySchoolForm from './Form/CommunitySchoolForm'

const CommunitySchoolModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const {
    addCommunitySchoolModal,
    setAddCommunitySchoolModal,
    communitySchoolData,
    setCommunitySchoolData,
  } = CommunitySchoolStore(store => ({
    addCommunitySchoolModal: store.addCommunitySchoolModal,
    setAddCommunitySchoolModal: store.setAddCommunitySchoolModal,
    communitySchoolData: store.communitySchoolData,
    setCommunitySchoolData: store.setCommunitySchoolData,
  }))

  const handleClose = () => {
    setCommunitySchoolData(undefined)
    setAddCommunitySchoolModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={addCommunitySchoolModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title={'Community School'}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <CommunitySchoolForm form={form} />
      </CustomModal>
    </>
  )
}

export default CommunitySchoolModal
